<script>
import Layout from '@layout/main'

export default {
  components: { Layout },
}
</script>

<!-- section template -->
<template>
  <Layout>
    <h1 :class="$style.title">
      The page timed out while loading. Are you sure you're still connected to
      the Internet?
    </h1>
  </Layout>
</template>

<!-- section style -->
<style lang="scss" module>
.title {
  text-align: center;
}
</style>
